export default __webpack_public_path__ + "i18n/translations/translation-de.193b598b.json";